//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IProductChangeHistoryClient {
    getProductChangeHistoryEntities(runId: string, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductChangeHistoryEntity[]>;
    getProductChangeHistory(runId: string, entityId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductChangeHistory>;
}

export class ProductChangeHistoryClient implements IProductChangeHistoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    getProductChangeHistoryEntities(runId: string , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductChangeHistoryEntity[]> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/productchangehistory/{runId}/entities";
        if (runId === undefined || runId === null)
            throw new globalThis.Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductChangeHistoryEntities(_response);
        });
    }

    protected processGetProductChangeHistoryEntities(response: AxiosResponse): Promise<ProductChangeHistoryEntity[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductChangeHistoryEntity[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductChangeHistoryEntity[]>(null as any);
    }

    getProductChangeHistory(runId: string, entityId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductChangeHistory> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/productchangehistory/{runId}/entities/{entityId}";
        if (runId === undefined || runId === null)
            throw new globalThis.Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        if (entityId === undefined || entityId === null)
            throw new globalThis.Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductChangeHistory(_response);
        });
    }

    protected processGetProductChangeHistory(response: AxiosResponse): Promise<ProductChangeHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductChangeHistory>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductChangeHistory>(null as any);
    }
}

export interface IProductSpecificationClient {
    getProductsForDelivery(definitionId: number, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductSpecification[]>;
}

export class ProductSpecificationClient implements IProductSpecificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    getProductsForDelivery(definitionId: number , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductSpecification[]> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/productspecification/productsfordelivery/{definitionId}";
        if (definitionId === undefined || definitionId === null)
            throw new globalThis.Error("The parameter 'definitionId' must be defined.");
        url_ = url_.replace("{definitionId}", encodeURIComponent("" + definitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductsForDelivery(_response);
        });
    }

    protected processGetProductsForDelivery(response: AxiosResponse): Promise<ProductSpecification[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductSpecification[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductSpecification[]>(null as any);
    }
}

export interface IPublicationClient {
    getLatestPublications(organisationId?: number | null | undefined, name?: string | null | undefined, type?: PublicationType | null | undefined, productGroupLabel?: string | null | undefined, status?: string | null | undefined, onlyActive?: boolean | null | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SearchResultOfPublicationFilterAndPublicationSearchResult>;
    getProductGroups(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<ProductGroup[]>;
    getPublicationDetail(publicationId: string, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<Publication>;
    getPublicationVersions(publicationId: string, onlyCompleted?: boolean | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<SearchResultOfPublicationVersionFilterAndPublicationVersionSearchResult>;
    getPublicationVersionDetail(publicationId: string, versionId: string, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<PublicationVersion>;
    getDeliveryFile(publicationId: string, versionId: string, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<FileResponse>;
    createPublication(json?: CreatePublication | undefined, files?: FileParameter[] | null | undefined, config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<PublicationCreated>;
    getPublicationStatistics(config?: AxiosRequestConfig | undefined, cancelToken?: CancelToken | undefined): Promise<PublicationStatistics>;
}

export class PublicationClient implements IPublicationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance, jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44323";
        this.jsonParseReviver = jsonParseReviver;
    }

    getLatestPublications(organisationId?: number | null | undefined, name?: string | null | undefined, type?: PublicationType | null | undefined, productGroupLabel?: string | null | undefined, status?: string | null | undefined, onlyActive?: boolean | null | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SearchResultOfPublicationFilterAndPublicationSearchResult> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/publication/latest?";
        if (organisationId !== undefined && organisationId !== null)
            url_ += "OrganisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (productGroupLabel !== undefined && productGroupLabel !== null)
            url_ += "ProductGroupLabel=" + encodeURIComponent("" + productGroupLabel) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (onlyActive !== undefined && onlyActive !== null)
            url_ += "OnlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        if (by !== undefined && by !== null)
            url_ += "By=" + encodeURIComponent("" + by) + "&";
        if (descending !== undefined && descending !== null)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestPublications(_response);
        });
    }

    protected processGetLatestPublications(response: AxiosResponse): Promise<SearchResultOfPublicationFilterAndPublicationSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SearchResultOfPublicationFilterAndPublicationSearchResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultOfPublicationFilterAndPublicationSearchResult>(null as any);
    }

    getProductGroups( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<ProductGroup[]> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/publication/productgroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProductGroups(_response);
        });
    }

    protected processGetProductGroups(response: AxiosResponse): Promise<ProductGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<ProductGroup[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductGroup[]>(null as any);
    }
    getPublicationDetail(publicationId: string , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<Publication> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/publication/{publicationId}";
        if (publicationId === undefined || publicationId === null)
            throw new globalThis.Error("The parameter 'publicationId' must be defined.");
        url_ = url_.replace("{publicationId}", encodeURIComponent("" + publicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicationDetail(_response);
        });
    }

    protected processGetPublicationDetail(response: AxiosResponse): Promise<Publication> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<Publication>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Publication>(null as any);
    }

    getPublicationVersions(publicationId: string, onlyCompleted?: boolean | undefined, by?: string | null | undefined, descending?: boolean | null | undefined, pageNumber?: number | null | undefined, pageSize?: number | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<SearchResultOfPublicationVersionFilterAndPublicationVersionSearchResult> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/publication/{publicationId}/versions?";
        if (publicationId === undefined || publicationId === null)
            throw new globalThis.Error("The parameter 'publicationId' must be defined.");
        url_ = url_.replace("{publicationId}", encodeURIComponent("" + publicationId));
        if (onlyCompleted === null)
            throw new globalThis.Error("The parameter 'onlyCompleted' cannot be null.");
        else if (onlyCompleted !== undefined)
            url_ += "OnlyCompleted=" + encodeURIComponent("" + onlyCompleted) + "&";
        if (by !== undefined && by !== null)
            url_ += "By=" + encodeURIComponent("" + by) + "&";
        if (descending !== undefined && descending !== null)
            url_ += "Descending=" + encodeURIComponent("" + descending) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicationVersions(_response);
        });
    }

    protected processGetPublicationVersions(response: AxiosResponse): Promise<SearchResultOfPublicationVersionFilterAndPublicationVersionSearchResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<SearchResultOfPublicationVersionFilterAndPublicationVersionSearchResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultOfPublicationVersionFilterAndPublicationVersionSearchResult>(null as any);
    }

    getPublicationVersionDetail(publicationId: string, versionId: string , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<PublicationVersion> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/publication/{publicationId}/versions/{versionId}";
        if (publicationId === undefined || publicationId === null)
            throw new globalThis.Error("The parameter 'publicationId' must be defined.");
        url_ = url_.replace("{publicationId}", encodeURIComponent("" + publicationId));
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicationVersionDetail(_response);
        });
    }

    protected processGetPublicationVersionDetail(response: AxiosResponse): Promise<PublicationVersion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<PublicationVersion>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationVersion>(null as any);
    }

    getDeliveryFile(publicationId: string, versionId: string , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/publication/{publicationId}/versions/{versionId}/file";
        if (publicationId === undefined || publicationId === null)
            throw new globalThis.Error("The parameter 'publicationId' must be defined.");
        url_ = url_.replace("{publicationId}", encodeURIComponent("" + publicationId));
        if (versionId === undefined || versionId === null)
            throw new globalThis.Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryFile(_response);
        });
    }

    protected processGetDeliveryFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createPublication(json?: CreatePublication | undefined, files?: FileParameter[] | null | undefined , config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<PublicationCreated> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/publication/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (json === null || json === undefined)
            throw new globalThis.Error("The parameter 'json' cannot be null.");
        else
            content_.append("Json", JSON.stringify(json));
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePublication(_response);
        });
    }

    protected processCreatePublication(response: AxiosResponse): Promise<PublicationCreated> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201, this.jsonParseReviver);
            return Promise.resolve<PublicationCreated>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationCreated>(null as any);
    }

    getPublicationStatistics( config?: AxiosRequestConfig | undefined , cancelToken?: CancelToken | undefined): Promise<PublicationStatistics> {
        let url_ = this.baseUrl + "/frontoffice/api/v1/publication/statistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            ...(config || {}),
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicationStatistics(_response);
        });
    }

    protected processGetPublicationStatistics(response: AxiosResponse): Promise<PublicationStatistics> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200, this.jsonParseReviver);
            return Promise.resolve<PublicationStatistics>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicationStatistics>(null as any);
    }
}

export interface ProductChangeHistoryEntity {
    id?: number;
    productEntityCode?: string;
    productEntityLabel?: string;
    hasHistory?: boolean;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface ProductChangeHistory {
    id?: number;
    currentCopies?: number;
    previousCopies?: number;
    newCopies?: number;
    changedCopies?: number;
    attributeChanges?: number;
    geometryChanges?: number;
    attributeAndGeometryChanges?: number;
    abolishedCopies?: number;
}

export interface ProductSpecification {
    id?: number;
    label?: string;
    isMetadataContinuous?: boolean;
    skipMapping?: boolean;
    skipMetadataPublication?: boolean;
    definition?: ProductProcessDefinition;
}

export interface ProductProcessDefinition {
    id?: number;
    label?: string;
    statusId?: number;
    deliveryDefinitionId?: number | null;
}

export interface SearchResultOfPublicationFilterAndPublicationSearchResult {
    filter?: PublicationFilter | null;
    results?: PublicationSearchResult[] | null;
    totalcount?: number | null;
    paging?: Paging | null;
    sorting?: Sorting | null;
}

export interface ProductGroup {
    id?: number;
    label?: string | null;
}

export interface PublicationFilter {
    organisationId?: number | null;
    name?: string | null;
    type?: PublicationType | null;
    productGroupLabel?: string | null;
    status?: string | null;
    onlyActive?: boolean | null;
}

export enum PublicationType {
    Dataset = 0,
    Datasetserie = 1,
}

export interface PublicationSearchResult {
    publicationType?: PublicationType;
    publicationStatus?: string | null;
    productDefinitionId?: string | null;
    productLabel?: string | null;
    productMetadataUUID?: string | null;
    versionDate?: Date | null;
    publicationDate?: Date | null;
}

export interface Paging {
    pageNumber?: number | null;
    pageSize?: number | null;
}

export interface Sorting {
    by?: string | null;
    descending?: boolean | null;
}

export interface Publication {
    id?: string;
    publicationType?: PublicationType;
    publicationStatus?: string | null;
    productLabel?: string | null;
    productDescription?: string | null;
    productMetadataUUID?: string | null;
    productDefinitionId?: number | null;
    organisationName?: string | null;
    versionNumber?: number;
    versionDate?: Date | null;
    versionDescription?: string | null;
    versionValidFrom?: Date | null;
    versionValidUntil?: Date | null;
    versionMetadataUUID?: string | null;
    publicationDate?: Date | null;
    deliveryDefinitionId?: number | null;
    deliveryStatus?: string | null;
    deliveryTriggerSchedule?: string | null;
    deliveryTriggerSourceId?: number | null;
    deliverySkipUpload?: boolean | null;
    newPublicationCheck?: NewPublicationCheck | null;
}

export interface NewPublicationCheck {
    allowPublication?: boolean;
    hasActiveDefinition?: boolean | null;
    hasPendingDelivery?: boolean | null;
    hasPendingPublication?: boolean | null;
    usesCodeLists?: boolean | null;
}

export interface SearchResultOfPublicationVersionFilterAndPublicationVersionSearchResult {
    filter?: PublicationVersionFilter | null;
    results?: PublicationVersionSearchResult[] | null;
    totalcount?: number | null;
    paging?: Paging | null;
    sorting?: Sorting | null;
}

export interface PublicationVersionFilter {
    onlyCompleted?: boolean;
}

export interface PublicationVersionSearchResult {
    id?: string;
    creationDate?: Date | null;
    deliveryStatusName?: string | null;
    productEndExecution?: Date | null;
    productStatusName?: string | null;
    versionDescription?: string | null;
}

export interface PublicationVersion {
    id?: string;
    creationDate?: Date | null;
    deliveryDefinitionId?: number | null;
    deliveryDefinitionLabel?: string | null;
    deliveryRunId?: number | null;
    deliveryRunGuid?: string | null;
    deliveryFileName?: string | null;
    deliveryFileContentType?: string | null;
    deliveryStartExecution?: Date | null;
    deliveryEndExecution?: Date | null;
    deliveryQualityReport?: string | null;
    deliveryIsDryRun?: boolean | null;
    deliveryStatusOn?: Date | null;
    deliveryStatusBy?: string | null;
    deliveryStatusId?: number | null;
    deliveryStatusName?: string | null;
    deliveryVersionDescription?: string | null;
    productDefinitionId?: number | null;
    productDefinitionLabel?: string | null;
    productLabel?: string | null;
    productRunId?: number | null;
    productRunGuid?: string | null;
    productIsFirstTime?: boolean | null;
    productIsDryRun?: boolean | null;
    productStartExecution?: Date | null;
    productEndExecution?: Date | null;
    productStatusOn?: Date | null;
    productStatusBy?: string | null;
    productStatusId?: number | null;
    productStatusName?: string | null;
    versionDate?: Date | null;
    versionDescription?: string | null;
    versionValidFrom?: Date | null;
    versionValidUntil?: Date | null;
    versionMetadataUUID?: string | null;
    productMetadataUUID?: string | null;
    isProductContinuous?: boolean | null;
    productSpecificationId?: number | null;
}

export interface PublicationCreated {
    id?: string;
}

export interface Product {
    versionDate?: Date | null;
    versionDescription?: string | null;
    temporalLimitationFrom?: Date | null;
    temporalLimitationTo?: Date | null;
    productSpecificationId?: number | null;
}

export interface CreatePublication {
    deliveryDefinitionId?: number;
    productDefinitionId?: number;
    products?: Product[];
}

export interface PublicationStatistics {
    organisationsCount?: number;
    continuousDatasetsCount?: number;
    discreteDatasetsCount?: number;
    continuousPublicationsCount?: number;
    discretePublicationsCount?: number;
    updatesCount?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}